// extracted by mini-css-extract-plugin
export default {"cardsList":"UsersList_cardsList__-K3tM"};